/**
 * Sentinel markers the preview sourcemap wraps around instrumented expressions.
 *
 * Emitted as Liquid *string literals* so they survive a render but vanish when a
 * conditional drops the output. The framing characters are C0 control chars that
 * should never appear in copy; if they do, `extractSourceMap` throws rather than
 * mis-attribute a range.
 *
 * This module stays dependency-free so browser-safe code can strip markers without
 * pulling in `render-template.ts` and its `node:crypto` import.
 */

const MARKER_FRAME_START = "\u0001";
export const SOURCEMAP_TERMINATOR = "\u0002";

export const SOURCEMAP_OPEN_PREFIX = `${MARKER_FRAME_START}HT_VAR_OPEN_`;
export const SOURCEMAP_CLOSE_PREFIX = `${MARKER_FRAME_START}HT_VAR_CLOSE_`;
export const SOURCEMAP_BLOCK_OPEN_PREFIX = `${MARKER_FRAME_START}HT_BLOCK_OPEN_`;
export const SOURCEMAP_BLOCK_CLOSE_PREFIX = `${MARKER_FRAME_START}HT_BLOCK_CLOSE_`;

/** A marker as it appears in an instrumented template, not as a rendered sentinel. */
const MARKER_OUTPUT_RE = new RegExp(
  `\\{\\{-?\\s*"${MARKER_FRAME_START}HT_(?:VAR|BLOCK)_(?:OPEN|CLOSE)_\\d+${SOURCEMAP_TERMINATOR}"\\s*-?\\}\\}`,
  "g",
);

export function stripSourcemapMarkerOutputs(template: string): string {
  if (!template.includes(MARKER_FRAME_START)) return template;
  return template.replace(MARKER_OUTPUT_RE, "");
}
